/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'
import { EffectCreative } from 'swiper/modules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function SlidingCoverMultiPreview({ srcs, redirectUrl }) {
  const [imageUrls, setImageUrls] = useState([])
  const swiperRef = useRef(null)
  const containerRef = useRef(null)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [swiperHeight, setSwiperHeight] = useState('auto')
  const [isSwiperFinished, setIsSwiperFinished] = useState(false)

  useEffect(() => {
    if (!srcs || !Array.isArray(srcs) || srcs.length === 0) {
      setImageUrls([])
      return
    }

    const urls = srcs
      .filter((img) => img.file)
      .map((img) =>
        img.file instanceof File || img.file instanceof Blob
          ? URL.createObjectURL(img.file)
          : img.file
      )

    setImageUrls(urls)

    return () => {
      // urls.forEach((url) => URL.revokeObjectURL(url))
    }
  }, [srcs])

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleScroll = () => {
      if (!swiperRef.current || !swiperRef.current.swiper) return

      const currentScrollY = container.scrollTop
      const scrollDiff = currentScrollY - lastScrollY

      if (Math.abs(scrollDiff) >= 100) {
        const swiperInstance = swiperRef.current.swiper
        swiperInstance.update()

        if (scrollDiff > 0) {
          swiperInstance.params.speed = 1500
          swiperInstance.params.effect = 'creative'

          setTimeout(() => {
            swiperInstance.slideNext()
          }, 60)
        } else {
          swiperInstance.params.speed = 2000
          swiperInstance.params.effect = 'creative'

          swiperInstance.slidePrev()
        }

        setLastScrollY(currentScrollY)
      }
    }

    container.addEventListener('scroll', handleScroll)

    return () => {
      container.removeEventListener('scroll', handleScroll)
    }
  }, [lastScrollY])

  useEffect(() => {
    const updateSwiperHeight = () => {
      if (swiperRef.current && swiperRef.current.el) {
        const height = swiperRef.current.el.offsetHeight
        setSwiperHeight(`${height}px`)
      }
    }

    updateSwiperHeight()
    window.addEventListener('resize', updateSwiperHeight)

    return () => {
      window.removeEventListener('resize', updateSwiperHeight)
    }
  }, [imageUrls])

  useEffect(() => {
    if (!swiperRef.current) return

    const swiperInstance = swiperRef.current.swiper

    swiperInstance.on('slideChange', () => {
      if (swiperInstance.activeIndex === swiperInstance.slides.length - 1) {
        setIsSwiperFinished(true)
      }
    })
  }, [])

  return (
    <div
      ref={containerRef}
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      {/* 頂部內容 */}
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {imageUrls.length > 0 && (
        <div
          id="swiper-box"
          style={{
            width: '100%',
            height: 'auto',
            minHeight: `${swiperHeight}px`,
            position: 'relative',
            zIndex: '1501',
          }}
        >
          <Swiper
            ref={swiperRef}
            effect="creative"
            grabCursor
            speed={1000}
            modules={[EffectCreative]}
            slidesPerView={1}
            loop={false}
            observer
            observeParents
            creativeEffect={{
              prev: {
                translate: ['-120%', '-120%', 0],
                rotate: [0, 0, 30],
                opacity: 1,
              },
              next: {
                translate: ['120%', '120%', 0],
                rotate: [0, 0, -30],
                opacity: 1,
              },
              current: {
                translate: [0, 0, 0],
                rotate: [0, -90, 0],
                opacity: 1,
              },
              previous: {
                translate: ['50%', '50%', 0],
                rotate: [0, 0, 30],
                opacity: 1,
              },
            }}
            className="swiper-creative swiper-slidingcovermulti"
            style={{
              width: '100%',
              height: 'auto',
              position: 'relative',
            }}
          >
            {imageUrls.map((image, index) => (
              <SwiperSlide key={index}>
                <a
                  href={redirectUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'block', width: '100%', height: '100%' }}
                >
                  <img
                    src={image}
                    alt={`Slide ${index}`}
                    style={{
                      width: '99%',
                      height: '100%',
                      objectFit: 'contain',
                      borderRadius: '0px',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                    }}
                  />
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
          <CIIcon />
        </div>
      )}

      {/* 底部內容 */}
      <div
        className="d-flex w-100 position-relative px-3 py-2"
        style={{
          marginTop: isSwiperFinished ? `${swiperHeight}px` : 'auto',
        }}
      />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <br />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
    </div>
  )
}

SlidingCoverMultiPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
    })
  ).isRequired,
  redirectUrl: PropTypes.string,
}

SlidingCoverMultiPreview.defaultProps = {
  redirectUrl: '',
}

export default SlidingCoverMultiPreview
